import CounterSection from 'components/common/CounterSection';

const AboutHistory = () => {
  return (
    <section className='relative z-10 DBlock py-12 px-6 md:px-10 bg-eventLightPink'>
      <img
        className='hidden sm:block absolute top-0 right-0 w-28 -z-10'
        src='/assets/images/about-us/curve.png'
        alt='curveImg'
      />
      <div className='max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-8'>
        <div className='lg:col-span-1'>
          <img
            className='w-full'
            src='/assets/images/about-us/aboutHistory.png'
            alt='aboutHistory'
          />
        </div>
        <div className='DBlock lg:col-span-2 sm:order-1'>
          <h2 className='sm:text-lg text-base font-semibold text-eventLightYellow uppercase pb-1'>
            ABOUT de evente
          </h2>
          <h1 className='sm:text-3xl text-lg xl:text-5xl uppercase font-bold'>
            Brief History
          </h1>
          <p className='text-eventGray text-sm py-4 lg:text-base md:max-w-2xl font-light'>
            JS Events & Productions is a 360 degree agency working in the areas
            of Events, Digital Marketing and Creative Brand Solutions. Founded
            first in the year 2000 as Pakistan`s first ever event management
            company JS has come a long way emerging and excelling in the fields
            of marketing and branding. Headquartered in Lahore, Pakistan we are
            the only Bespoke events agency from Pakistan to have an
            International existence as well.JS has come a long way emerging and
            excelling in the fields of marketing and branding. Headquartered in
            Lahore, Pakistan we are the only Bespoke events agency from Pakistan
            to have an International existence as well.
          </p>
          <CounterSection />
        </div>
      </div>
    </section>
  );
};

export default AboutHistory;
